<template>
  <!-- <div>cmd k + cmd j then cmd k + cmd 6</div> -->
  <v-dialog v-model="dialog" persistent>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ showSection ? "協助預約" : "修改問卷" }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <template v-if="index == 0">
            <v-container>
              <div class="text-h5 font-weight-bold">目前健康狀況</div>
            </v-container>
            <ItemCheck
              :person.sync="person"
              :valid.sync="valid"
              :目前狀態.sync="目前狀態"
              @update="changeStatus"
            ></ItemCheck>
          </template>

          <template v-if="index == 1">
            <Q1
              :person.sync="person"
              :valid.sync="valid"
              :問卷.sync="問卷"
            ></Q1>
          </template>

          <template v-if="index == 2">
            <Q2
              :person.sync="person"
              :valid.sync="valid"
              :問卷.sync="問卷"
            ></Q2>
          </template>

          <template v-if="index == 3">
            <Q3
              :person.sync="person"
              :valid.sync="valid"
              :問卷.sync="問卷"
            ></Q3>
          </template>

          <template v-if="index == 4">
            <Q4
              :person.sync="person"
              :valid.sync="valid"
              :問卷.sync="問卷"
            ></Q4>
          </template>

          <template v-if="index == 5">
            <Q5
              :person.sync="person"
              :valid.sync="valid"
              :問卷.sync="問卷"
            ></Q5>
          </template>

          <template v-if="index == 6">
            <v-container>
              <div class="text-h5 font-weight-bold">選擇預約場次</div>
            </v-container>
            <reserveSection
              v-if="dialog"
              v-model="section"
              :selectedPerson="person"
              class="mt-4"
              style="max-width: 400px; margin: 0 auto"
            ></reserveSection>
          </template>
        </v-form>
        <v-row justify="center" class="mt-4">
          <v-col class="col-auto" v-if="index != 0">
            <v-btn @click="prev">上一頁</v-btn>
          </v-col>
          <v-col class="col-auto">
            <v-btn @click="next" v-if="!finalPage">下一頁</v-btn>
            <v-btn @click="submit" v-else color="primary">送出</v-btn>
          </v-col>
          <v-col class="col-auto">
            <v-btn color="warning" @click="skip" v-if="!finalPage">
              全部略過
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false"> 關閉 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ItemCheck from "@/components/QuestionContent/ItemCheck";
import reserveSection from "@/components/People/reserveSection.vue";
import Q1 from "@/components/QuestionContent/Q1";
import Q2 from "@/components/QuestionContent/Q2";
import Q3 from "@/components/QuestionContent/Q3";
import Q4 from "@/components/QuestionContent/Q4";
import Q5 from "@/components/QuestionContent/Q5";
export default {
  name: "Question",
  props: ["value", "thePerson"],
  components: { ItemCheck, Q1, Q2, Q3, Q4, Q5, reserveSection },
  data: () => ({
    index: 0,
    valid: false,
    person: null,
    目前狀態: null,
    問卷: null,
    section: null,
  }),
  computed: {
    showSection() {
      return !this.person._id;
    },
    finalPage() {
      let finalIndex = 5;
      if (this.性別 == "男") finalIndex = 4;
      if (this.showSection) finalIndex = 6;
      return this.index >= finalIndex;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    性別() {
      switch (this.person.身分證字號[1]) {
        case "1":
        case "A":
        case "C":
          return "男";
          break;
        case "2":
        case "B":
        case "D":
          return "女";
          break;
      }
    },
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      this.person = { ...this.thePerson };
      this.問卷 = this.person.問卷 || {};
      this.目前狀態 = this.person.目前狀態 || {
        我目前有嚼食檳榔的習慣: false,
        我過去曾經有嚼食檳榔的習慣: false,
        我目前有吸菸的習慣: false,
        我過去曾經有吸菸的習慣: false,
        我有大腸癌病史: false,
        我有大腸癌家族史: false,
        我有肺癌家族史: false,
        我曾經有過性行為: false,
        我目前懷孕中: false,
        我有乳癌病史或乳癌家族史: false,
      };
      await this.changeStatus();
    },
    async changeStatus() {
      let 篩檢項目 = (
        await this.axios.post(
          `/dashboard/person/pre-check/${this.person.身分證字號}`,
          this.目前狀態
        )
      ).data.篩檢項目;
      this.person.篩檢項目 = 篩檢項目;
      this.person.目前狀態 = this.目前狀態;
    },
    async next() {
      // if (!this.$store.state.user) {
      // this.valid = this.$refs.form.validate();
      // }
      if (this.valid) {
        if (!this.finalPage) this.index++;
      }
    },
    async prev() {
      if (this.index > 0) this.index--;
      if (this.性別 == "男" && this.index == 5) this.index--;
    },
    async skip() {
      this.index = 5;
    },
    async submit() {
      this.person.問卷 = this.問卷;
      this.person.目前狀態 = this.目前狀態;
      // this.valid = this.$refs.form.validate();
      this.valid = true;
      if (this.valid) {
        if (this.showSection) {
          if (this.section) {
            try {
              await this.axios.post("/dashboard/person/reserve", {
                person: this.person,
                section: this.section,
              });
              this.$toast.success("預約成功！");
              this.dialog = false;
              this.$emit("load");
            } catch (e) {
              this.$toast.error("無法預約此時段，請選擇其他時段！");
            }
          } else {
            this.$toast.error("請選擇預約時段！");
          }
        } else {
          if (confirm("確認修改問卷？")) {
            try {
              await this.axios.post(
                `/dashboard/person/${this.person.身分證字號}`,
                this.person
              );
              this.$toast.success("修改成功");
              this.dialog = false;
              this.$emit("load");
            } catch (e) {
              this.$toast.error("修改失敗");
            }
          }
        }
      }
    },
  },
  watch: {
    async dialog(val) {
      if (val) {
        this.index = 0;
        await this.init();
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
